import {Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs';

@Directive({
    selector: '[appCustomRouterLinkActive]',
    standalone: false
})
export class CustomRouterLinkActiveDirective implements OnInit, OnDestroy {
    @Input('appCustomRouterLinkActive') customRouterLinkActive!: string; // The class to add when active
    @Input() customCondition!: (...args: any) => boolean; // The custom condition function
    @Input() dynamicParamForCondition!: any;

    private subscription!: Subscription;

    constructor(private router: Router, private el: ElementRef, private renderer: Renderer2) {
    }

    ngOnInit(): void {
        this.subscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.updateClass();
            }
        });

        this.updateClass();
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    private updateClass(): void {
        const condition: boolean = typeof this.dynamicParamForCondition !== 'undefined' ? this.customCondition(this.dynamicParamForCondition) : this.customCondition();
        if (condition) {
            this.renderer.addClass(this.el.nativeElement, this.customRouterLinkActive);
        } else {
            this.renderer.removeClass(this.el.nativeElement, this.customRouterLinkActive);
        }
    }
}
